import { usePageMetadata } from '../hooks/usePageMetadata'

export default function TermsOfUse() {
  usePageMetadata({
    title: 'Terms of Use | Places in Time',
    description:
      'Review the terms for using Places in Time, including acceptable use, intellectual property, account responsibilities, and liability limits.',
    path: '/terms-of-use',
  })

  return (
    <main className="page legal-page">
      <section className="page-hero">
        <h1>Terms of Use</h1>
        <p>
          These terms explain how you may access and use Places in Time, including the atlas, chat experience, and any
          downloadable resources. By visiting the site you agree to follow the guidelines below.
        </p>
      </section>

      <section className="page-section">
        <h2>Acceptable use</h2>
        <p>
          You may use Places in Time for personal, educational, or professional planning so long as you do not infringe
          on the rights of others, attempt to reverse engineer the service, or interfere with site performance. Automated
          scraping or bulk exporting of content is not permitted without written permission.
        </p>
      </section>

      <section className="page-section">
        <h2>Intellectual property</h2>
        <p>
          All copy, imagery, logos, and interface elements belong to Places in Time or our partners. You may reference
          the material with attribution but may not resell or repackage the experience. External trademarks remain the
          property of their respective owners.
        </p>
      </section>

      <section className="page-section">
        <h2>Accounts &amp; security</h2>
        <p>
          You are responsible for safeguarding your login credentials and notifying us immediately if you suspect
          unauthorized access. We reserve the right to suspend accounts that violate these terms or pose security risks.
        </p>
      </section>

      <section className="page-section">
        <h2>Liability</h2>
        <p>
          Places in Time is provided “as is.” While we work hard to keep information accurate, we cannot guarantee every
          detail or the availability of third-party sites we reference. To the fullest extent allowed by law we disclaim
          liability for damages resulting from use of the site.
        </p>
      </section>

      <section className="page-section">
        <h2>Changes &amp; contact</h2>
        <p>
          We may update these terms as the product evolves. Continued use after changes take effect means you accept the
          revised terms. Questions can be sent to legal@places-in-time.com.
        </p>
      </section>
    </main>
  )
}
